(() => {
  const button = document.querySelector('.hm-whatsapp');
  let pending = false;
  const update = () => {
    pending = false;
    if (!button) return;
    const view = window.visualViewport;
    const height = view ? view.height + view.offsetTop : innerHeight;
    const width = document.documentElement.clientWidth;
    const right = width - (width < 768 ? 12 : 18);
    const left = right - button.offsetWidth;
    let bottom = innerHeight - height + 16;
    // Move above visible purchase bars, navigation, consent banners and buy buttons.
    const obstacles = document.querySelectorAll('.app-nav,.sticky-purchase,[data-product-add],.shopify-payment-button,button[name="add"],#shopify-pc__banner,#shopify-pc__prefs,#onetrust-banner-sdk,.cc-window,[id*="cookie-banner"],[class*="cookie-banner"],[role="dialog"],[aria-modal="true"]');
    const rects = [...obstacles].filter(el => {
      const style = getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
    }).map(el => el.getBoundingClientRect()).filter(r => r.width && r.height && r.top < height && r.bottom > 0 && r.left < right && r.right > left);
    for (let pass = 0; pass <= rects.length; pass++) {
      const top = innerHeight - bottom - button.offsetHeight;
      const hit = rects.find(r => top < r.bottom + 12 && innerHeight - bottom > r.top - 12);
      if (!hit) break;
      bottom = innerHeight - hit.top + 12;
    }
    const value = Math.ceil(bottom) + 'px';
    if (button.style.bottom !== value) button.style.bottom = value;
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  document.addEventListener('transitionend', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','style','hidden','open'] });
  new ResizeObserver(schedule).observe(document.body);
  schedule();

})();
// Make the original description photos accessible at full size on touch screens.
(() => {
  const setup = () => {
    const copy = document.querySelector('.story-copy .rte');
    if (!copy) return;
    const fr = document.documentElement.lang.startsWith('fr');
    let linked = false;
    copy.querySelectorAll('img').forEach(img => {
      if (img.closest('a') || !img.getAttribute('src')) return;
      let url;
      try { url = new URL(img.getAttribute('src'), location.href); } catch { return; }
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
      const a = document.createElement('a');
      a.className = 'hm-description-image-link';
      a.href = url.href;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.setAttribute('aria-label', (fr ? 'Agrandir l’image' : 'Ingrandisci immagine') + (img.alt ? ': ' + img.alt : '') + (fr ? ' (nouvel onglet)' : ' (nuova scheda)'));
      img.before(a);
      a.append(img);
      linked = true;
    });
    if (linked && !copy.previousElementSibling?.classList.contains('hm-description-image-hint')) {
      const hint = document.createElement('p');
      hint.className = 'hm-description-image-hint';
      hint.textContent = fr ? 'Touchez une photo pour l’agrandir.' : 'Tocca una foto per ingrandirla.';
      copy.before(hint);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
